import { SelectListItemModel } from '../select.list.item.model';

export class UserGroupSelectList {
    key: string;
    value: string;
    users: SelectListItemModel[];
}
